export default __webpack_public_path__ + "1586276b9e073e470ae24705367809ab.svg";